import type { MantineSpacing } from "@mantine/core";

/** The space above and below each divider in the dropdown: between groups, and above the create row. */
export const DIVIDER_SPACING: MantineSpacing = "xs";
